'use client';

import { useEffect } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useTranslation } from '@/hooks/useTranslation';

export default function TeamsConfigPage() {
  const { t } = useTranslation();

  useEffect(() => {
    const teams = (typeof window !== 'undefined' ? (window as any).microsoftTeams : null);
    if (!teams?.app) {
      return;
    }

    teams.app.initialize();

    teams.pages.config.registerOnSaveHandler(() => {
      teams.pages.config.setConfig({
        entityId: 'meeting-attendance',
        contentUrl: `${window.location.origin}/meetingattendance/teams/meetings`,
        suggestedDisplayName: t.meetingAttendance.teamsConfig.appName,
        websiteUrl: `${window.location.origin}/meetingattendance/dashboard`,
      });

      teams.app.notifySuccess(t.meetingAttendance.teamsConfig.saveSuccess);
    });

    teams.pages.config.setValidityState(true);
  }, [t.meetingAttendance.teamsConfig.appName, t.meetingAttendance.teamsConfig.saveSuccess]);

  const handleSaveConfiguration = () => {
    const teams = (typeof window !== 'undefined' ? (window as any).microsoftTeams : null);
    if (!teams?.pages?.config) {
      return;
    }

    teams.pages.config.setConfig({
      entityId: 'meeting-attendance',
      contentUrl: `${window.location.origin}/meetingattendance/teams/meetings`,
      suggestedDisplayName: t.meetingAttendance.teamsConfig.appName,
      websiteUrl: `${window.location.origin}/meetingattendance/dashboard`,
    });
  };

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md mx-auto">
        <Card>
          <CardHeader className="text-center">
            <CardTitle>{t.meetingAttendance.teamsConfig.title}</CardTitle>
            <CardDescription>{t.meetingAttendance.teamsConfig.subtitle}</CardDescription>
          </CardHeader>
          <CardContent className="space-y-6">
            <div className="text-center">
              <div className="mb-4">
                <h3 className="text-lg font-medium text-gray-900 mb-2">
                  {t.meetingAttendance.teamsConfig.featuresTitle}
                </h3>
                <ul className="text-sm text-gray-600 space-y-1">
                  <li>{t.meetingAttendance.teamsConfig.featuresMeetings}</li>
                  <li>{t.meetingAttendance.teamsConfig.featuresCheckin}</li>
                  <li>{t.meetingAttendance.teamsConfig.featuresStats}</li>
                  <li>{t.meetingAttendance.teamsConfig.featuresReports}</li>
                </ul>
              </div>

              <div className="mb-6">
                <h3 className="text-lg font-medium text-gray-900 mb-2">
                  {t.meetingAttendance.teamsConfig.permissionTitle}
                </h3>
                <p className="text-sm text-gray-600">
                  {t.meetingAttendance.teamsConfig.permissionDesc}
                </p>
              </div>

              <Button onClick={handleSaveConfiguration} className="w-full">
                {t.meetingAttendance.teamsConfig.saveAction}
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
      <script
        src="https://res.cdn.office.net/teams-js/2.0.0/js/MicrosoftTeams.min.js"
        async
      ></script>
    </div>
  );
}
